<template>
  <div class="app-chrome">
    <loading-indicator v-if="isLoadingCurrentUser || isLoading"></loading-indicator>
    <div v-else>
      <page403 v-if="isUnauthorize"></page403>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { Validator } from 'vee-validate';
import LoadingIndicator from 'components/LoadingIndicator';
import StorageManager from 'src/managers/StorageManager';

export default {
  components: {
    LoadingIndicator,
  },
  watch: {
    isLoadingCurrentUser: function() {
      this.checkAuthorize();
    },
    currentUser: function(value) {
      if (value) {
        const namespace = this.currentUser.team.namespace;

        this.$i18n.locale = this.currentUser.lang;
        Validator.setLocale(this.currentUser.lang);

        // check lang in local storage
        this.storage.getLang(namespace).then((lang) => {
          if (lang !== this.currentUser.lang) {
            this.storage.setLang(this.currentUser.lang, namespace);
          }
        });

        this.requestPaymentCallback();
      }
    },
  },
  computed: {
    ...mapGetters([
      'isLoadingCurrentUser',
      'currentUser',
    ]),
  },
  data: function() {
    return {
      isLoading: false,
      isUnauthorize: false,
      storage: null,
    };
  },
  created: function() {
    this.storage = new StorageManager();

    this.$store.dispatch('getCurrentUser');
  },
  mounted: function() {

  },
  methods: {
    checkAuthorize: function() {
      if (this.currentUser) {
        if (this.$route.matched.some(record => record.meta.requiresManager)) {
          if (this.currentUser.role !== 'manager') {
            //redirect 403
            this.isUnauthorize = true;
            return;
          }
        } else if (this.$route.matched.some(record => record.meta.requiresSuperAdmin)) {
          if (!this.currentUser.team.is_superadmin) {
            //redirect 403
            this.isUnauthorize = true;
            return;
          }
        }
      }
      this.isUnauthorize = false;
    },
    requestPaymentCallback: function() {
      const paymentId = this.$route.params.id;
      const queryParams = this.$route.query;

      this.isLoading = true;
      axios.get(`/api/payment/return/${paymentId}`, {
        params: queryParams,
      })
      .then(() => {
        // redirect to billing page with success response
        this.isLoading = false;
        const namespace = this.$route.params.namespace;
        this.$router.push({ path: `/${namespace}/billing`, query: { result: 'success' } });
      })
      .catch(() => {
        // redirect to billing page with error response
        this.isLoading = false;
        const namespace = this.$route.params.namespace;
        this.$router.push({ path: `/${namespace}/billing`, query: { result: 'fail' } });
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// PaymentResponse.vue?3a13270a